import { FCX } from "@datassential/platform-ui-lib";
import './PermissionOverlay.scss';
import cn from "classnames";
import React, { useState } from "react";

type ContentStyleModifier = 'bottom' | 'opaque' | 'small-text' | 'small-p' | 'no-bg';

const PermissionOverlay: FCX<{
    onContactUsClick: () => void;
    contentStyleModifiers?: ContentStyleModifier[];
}> = ({
    onContactUsClick,
    contentStyleModifiers,
    children,
    testId,
}) => {
    const [isRequestSent, setIsRequestSent] = useState(false);
    return (
        <div
            className="FoodPermissionOverlay"
            data-testid={testId}
        >
            <div
                className={cn(
                    "FoodPermissionOverlay__content",
                    ...(contentStyleModifiers ?? []).map(modifier => `is-${modifier}`),
                )}
                data-testid="blockFoodPermissionOverlayContent"
            >
                {children}
                <div
                    className="FoodPermissionOverlay__footer"
                    data-testid="blockFoodPermissionOverlayFooter"
                >
                    {isRequestSent ? (<>
                        Thank you for your request,{' '}
                        {contentStyleModifiers?.includes('bottom') ? null : <br/>}
                        we will get back to you shortly!
                    </>) : (<>
                        <button
                            type="button"
                            className="FoodPermissionOverlay__button"
                            data-testid="buttonFoodPermissionOverlayContactUs"
                            onClick={() => {
                                onContactUsClick();
                                setIsRequestSent(true);
                            }}
                        >
                            Contact us
                        </button>
                        &nbsp;to learn more
                    </>)}
                </div>
            </div>
        </div>
    );
}

export default PermissionOverlay;